<template>
  <new-edit-page
    :is-loading="loading"
    :page-title="pageTitle"
    :submit-button-label="submitButtonLabel"
    :submit-button-disabled="submitButtonDisabled"
    @submit="saveObject"
    style="width: 100%"
    one-section-only
    :toggle-field-button="actionType === 'edit'"
    :toggle-button-label="customField.disable ? $t('Enable') : $t('Disable')"
    @toggleField="toggleField"
  >
    <template v-slot:wholeSection>
      <custom-field-fields :customField="customField" />
    </template>
  </new-edit-page>
</template>

<script>
import { mapActions } from "vuex";
import NewEditPage from "@/components/Management/NewEditPage/NewEditPage";
import { customFieldsMixin } from "@/mixins/customFieldsMixin";
import CustomFieldFields from "./CustomFieldFields";
import _ from "lodash";

export default {
  name: "CustomFieldsCreateEdit",

  components: {
    NewEditPage,
    CustomFieldFields
  },

  mixins: [customFieldsMixin],

  data() {
    return {
      loading: false,

      customField: {
        code: "",
        label: "",
        object_type: undefined,
        input_type: undefined,
        default_value: null,
        required: false,
        size: undefined,
        list_name: undefined,
        table: undefined
      }
    };
  },

  computed: {
    customFieldUuid() {
      return this.$route.params.uuid;
    },

    actionType() {
      let routeName = this.$route.name;
      if (routeName === "custom-field-edit") {
        return "edit";
      } else if (routeName === "custom-field-create") {
        return "create";
      }
    },

    pageTitle() {
      return this.actionType === "create"
        ? this.$t("NewCustomField")
        : this.$t("EditCustomField");
    },

    submitButtonLabel() {
      return this.actionType === "create" ? this.$t("Create") : this.$t("Save");
    },

    submitButtonDisabled() {
      if (this.customField) {
        return (
          this.customField.code === "" ||
          this.customField.label === "" ||
          !this.customField.table ||
          !this.customField.input_type ||
          !this.customField.size
        );
      }
    }
  },

  mounted() {
    if (this.actionType === "edit") {
      this.getObject();
    }
  },

  methods: {
    ...mapActions([
      "fetchCustomFieldByUuid",
      "editCustomField",
      "createCustomField"
    ]),

    async getObject() {
      if (this.customFieldUuid) {
        this.loading = true;
        try {
          this.customField = await this.fetchCustomFieldByUuid(
            this.customFieldUuid
          );
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
        }
      }
    },

    async saveObject() {
      this.loading = true;
      try {
        let dataToSend = _.cloneDeep(this.customField);
        if (this.actionType === "create") {
          await this.createCustomField({
            label: dataToSend.label,
            object_type: dataToSend.object_type,
            table: dataToSend.table,
            input_type: dataToSend.input_type,
            size: dataToSend.size,
            required: dataToSend.required,
            disable: false,
            default_value: dataToSend.default_value,
            list_name: dataToSend.list_name,
            code: dataToSend.code,
            index: dataToSend.index
          });
        } else {
          await this.editCustomField(dataToSend);
        }
      } catch (e) {
        this.$toasted.global.toast_error(e.response.data.data);
      } finally {
        this.$router.back();
        this.loading = false;
      }
    },

    toggleField() {
      this.customField.disable = !this.customField.disable;
      this.saveObject();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsCreateEdit.vue